/*
  Pet Royale: varyasyon secilince sayfa en tepeye DEGIL, urun galerisinin ust kenari
  sabit (sticky) basligin hemen altina gelecek sekilde kaydirilir. Boylece buyuk foto,
  kucuk gorseller, urun basligi ve fiyat tam gorunur (kullanici karari 22 Ekim).
  Masaustu ve mobilde ayni mantik: hedef = galeri ust kenari - sabit baslik yuksekligi - 8px.
  Kullanici zaten galerinin ustundeyse (hedefin ustunde) asagi kaydirma yapilmaz.
  Urun kartlari ve hizli-ekle pencereleri haric tutulur.
*/
(function () {
  var GAP = 8;

  function isExcludedContext(el) {
    return !!(el.closest('product-card') || el.closest('quick-add-dialog'));
  }

  function findGallery(sourceElement) {
    var section = (sourceElement && sourceElement.closest('.shopify-section')) || document;
    return (
      section.querySelector('.product-carousel') ||
      section.querySelector('media-carousel-thumbnails') ||
      section.querySelector('.product-info') ||
      section.querySelector('h1') ||
      document.querySelector('.product-carousel') ||
      document.querySelector('h1')
    );
  }

  function headerOffset() {
    var h = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    if (!h) return 0;
    var pos = window.getComputedStyle(h).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    return h.offsetHeight || 0;
  }

  function handleVariantSelection(sourceElement) {
    try {
      if (!sourceElement || typeof sourceElement.closest !== 'function') return;
      if (isExcludedContext(sourceElement)) return;
      var gallery = findGallery(sourceElement);
      if (!gallery) return;

      var current = window.scrollY || document.documentElement.scrollTop || 0;
      var target = gallery.getBoundingClientRect().top + current - headerOffset() - GAP;
      if (target < 0) target = 0;

      // Sadece kullanici galerinin altina inmisse yukari kaydir.
      if (current - target > 40) {
        try {
          window.scrollTo({ top: target, left: 0, behavior: 'smooth' });
        } catch (e) {
          window.scrollTo(0, target);
        }
      }
    } catch (e) {
      if (window.console && console.warn) console.warn('[petelite-variant-scroll]', e);
    }
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var picker = target.closest('variant-picker');
      if (!picker) return;
      handleVariantSelection(picker);
    },
    true
  );

  var lastRun = 0;
  function onProductSelect(event) {
    var now = Date.now();
    if (now - lastRun < 300) return;
    lastRun = now;
    handleVariantSelection(event.target);
  }
  document.addEventListener('shopify:product:select', onProductSelect);
  window.addEventListener('shopify:product:select', onProductSelect);
})();
